import React, { useEffect, useState } from "react";
import './styles.css'

const BusinessDashboard = props => {
    return (
        <></>
    )
}

export default BusinessDashboard